import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
Vue.use(VueRouter);
const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    //金融服务 -> 知识产权质物处置
    path: "/financialservice2",
    name: "financialservice2",
    component: () =>
      import(
        /* webpackChunkName: "FinancialService" */ "../views/financial/FinancialService2.vue"
      ),
  },
  {
    //金融服务 -> 知识产权质押融资
    path: "/financialservice",
    name: "financialservice",
    component: () =>
      import(
        /* webpackChunkName: "FinancialService" */ "../views/financial/FinancialService.vue"
      ),
  },
  {
    //金融服务 -> 知识产权质押融资 -> 融资申请
    path: "/apply",
    name: "apply",
    meta: {
      requireAuth: true, // 判断是否需要登录
    },
    component: () =>
      import(/* webpackChunkName: "Apply" */ "../views/financial/Apply.vue"),
  },
  {
    //金融服务 -> 知识产权资本运作
    path: "/capitaloperation",
    name: "capitaloperation",
    component: () =>
      import(
        /* webpackChunkName: "CapitalOperation" */ "../views/financial/CapitalOperation.vue"
      ),
  },
  {
    //金融服务 -> 服务科创板
    path: "/service",
    name: "service",
    component: () =>
      import(
        /* webpackChunkName: "Service" */ "../views/financial/Service.vue"
      ),
  },
  {
    //查看更多
    path: "/seemore",
    name: "seemore",
    component: () =>
      import(/* webpackChunkName: "SeeMore" */ "../views/SeeMore.vue"),
    meta: { keepAlive: true },
  },
  {
    //详情
    path: "/details",
    name: "details",
    component: () =>
      import(/* webpackChunkName: "Details" */ "../views/Details.vue"),
  },
  {
    //详情
    path: "/detailsEmbed",
    name: "detailsEmbed",
    component: () =>
      import(/* webpackChunkName: "DetailsEmbed" */ "../views/DetailsEmbed.vue"),
  },
  {
    //详情->发起受让
    path: "/details/initiatingassignment",
    name: "initiatingassignment",
    meta: {
      requireAuth: true, // 判断是否需要登录
    },
    component: () =>
      import(
        /* webpackChunkName: "InitiatingAssignment" */ "../views/InitiatingAssignment.vue"
      ),
  },
  {
    //企业认证列表
    path: "/enterprisecertification",
    name: "enterprisecertification",
    meta: {
      requireAuth: true, // 判断是否需要登录
    },
    component: () =>
      import(
        /* webpackChunkName: "EnterpriseCertification" */ "../views/EnterpriseCertification.vue"
      ),
  },
  {
    //第三方企业认证列表
    path: "/enterprisethirdparty",
    name: "enterprisethirdparty",
    meta: {
      requireAuth: true, // 判断是否需要登录
    },
    component: () =>
      import(
        /* webpackChunkName: "EnterpriseThirdParty" */ "../views/EnterpriseThirdParty.vue"
      ),
  },
  {
    //发布标的
    path: "/transferregistration",
    name: "transferregistration",
    meta: {
      requireAuth: true, // 判断是否需要登录
    },
    component: () =>
      import(
        /* webpackChunkName: "TransferRegistration" */ "../views/TransferRegistration.vue"
      ),
  },
  {
    //个人中心
    path: "/my",
    name: "my",
    component: () => import(/* webpackChunkName: "My" */ "../views/My.vue"),
    meta: {
      requireAuth: true, // 判断是否需要登录
    },
  },
  {
    //个人中心
    path: "/myembed",
    name: "myembed",
    component: () => import(/* webpackChunkName: "MyEmbed" */ "../views/MyEmbed.vue"),
    meta: {
      requireAuth: true, // 判断是否需要登录
    },
  },
  {
    //转让详情
    path: "/my/zhuanrang",
    name: "zhuanrang",
    component: () =>
      import(/* webpackChunkName: "ZhuanRang" */ "../views/see/ZhuanRang.vue"),
    meta: {
      requireAuth: true, // 判断是否需要登录
    },
  },
  {
    //受让详情
    path: "/my/shourang",
    name: "shourang",
    component: () =>
      import(/* webpackChunkName: "ShouRang" */ "../views/see/ShouRang.vue"),
    meta: {
      requireAuth: true, // 判断是否需要登录
    },
  },
  {
    //合作机构
    path: "/partners",
    name: "partners",
    component: () =>
      import(/* webpackChunkName: "Partners" */ "../views/Partners.vue"),
  },
  {
    //我的收藏
    path: "/collection",
    name: "collection",
    meta: {
      requireAuth: true, // 判断是否需要登录
    },
    component: () =>
      import(/* webpackChunkName: "Collection" */ "../views/Collection.vue"),
  },
  {
    //重点产业
    path: "/keyindustries",
    name: "keyindustries",
    component: () =>
      import(
        /* webpackChunkName: "KeyIndustries" */ "../views/KeyIndustries.vue"
      ),
  },
  {
    //新闻详情页
    path: "/nes",
    name: "nes",
    component: () =>
      import(/* webpackChunkName: "nes" */ "../views/nes/index.vue"),
  },
  {
    //新闻列表页
    path: "/newslist",
    name: "newslist",
    component: () =>
      import(/* webpackChunkName: "newslist" */ "../views/nes/NewsList.vue"),
  },
  {
    //公告详情页
    path: "/noti",
    name: "noti",
    component: () =>
      import(/* webpackChunkName: "noti" */ "../views/noti/index.vue"),
  },
  {
    //公告列表页
    path: "/notilist",
    name: "notilist",
    component: () =>
      import(/* webpackChunkName: "notilist" */ "../views/noti/List.vue"),
  },
  {
    //政策规则详情页
    path: "/policy",
    name: "policy",
    component: () =>
      import(/* webpackChunkName: "policy" */ "../views/policy/index.vue"),
  },
  {
    //政策规则列表页
    path: "/policylist",
    name: "policylist",
    component: () =>
      import(/* webpackChunkName: "policylist" */ "../views/policy/List.vue"),
  },
  {
    //开发许可详情页
    path: "/open",
    name: "open",
    component: () =>
      import(/* webpackChunkName: "open" */ "../views/open/index.vue"),
  },
  {
    //开发许可列表页
    path: "/openlist",
    name: "openlist",
    component: () =>
      import(/* webpackChunkName: "openlist" */ "../views/open/List.vue"),
  },
  {
    //专利超市页面
    path: "/supermarket",
    name: "supermarket",
    component: () =>
      import(/* webpackChunkName: "openlist" */ "../views/Supermarket.vue"),
  },
  {
    //信息互联页面
    path: "/interconnection",
    name: "interconnection",
    component: () =>
      import(/* webpackChunkName: "openlist" */ "../views/Interconnection.vue"),
  },
  {
    //信息互联详情
    path: "/interconnection/details",
    name: "interconnectionDetail",
    component: () =>
      import(/* webpackChunkName: "openlist" */ "../views/InterconnectionDetails.vue"),
  },
  {
    //版权服务页面
    path: "/copyright_services",
    name: "copyright_services",
    component: () =>
      import(/* webpackChunkName: "openlist" */ "../views/CopyrightServices.vue"),
  },
  {
    //兰博基尼列表
    path: "/lamborghini",
    name: "lamborghini",
    component: () =>
      import(/* webpackChunkName: "openlist" */ "../views/Lamborghini.vue"),
  },
  {
    //兰博基尼详情
    path: "/copyright_details",
    name: "copyright_details",
    component: () =>
      import(/* webpackChunkName: "openlist" */ "../views/CopyrightDetails.vue"),
  },
  {
    //成交公告列表页
    path: "/deal",
    name: "deal",
    component: () =>
      import(/* webpackChunkName: "deal" */ "../views/deal/index.vue"),
  },
  {
    //成交公告详情页
    path: "/deal/details",
    name: "details",
    component: () =>
      import(/* webpackChunkName: "deal" */ "../views/deal/Details.vue"),
  },
  {
    //关于我们 -> 信息公开
    path: "/information",
    name: "information",
    component: () =>
      import(
        /* webpackChunkName: "information" */ "../views/About/Information.vue"
      ),
  },
  {
    //关于我们 -> 信息公开 -> 招聘信息
    path: "/recruit",
    name: "recruit",
    component: () =>
      import(/* webpackChunkName: "recruit" */ "../views/About/Recruit.vue"),
  },
  {
    //国际业务 -> 国际联盟
    path: "/union",
    name: "union",
    component: () =>
      import(
        /* webpackChunkName: "union" */ "../views/InternationalBusiness/Union.vue"
      ),
  },
  {
    //运营服务 -> IP咨询
    path: "/consult",
    name: "consult",
    component: () =>
      import(
        /* webpackChunkName: "consult" */ "../views/Operate/Consult.vue"
      ),
  },
  {
    //运营服务 -> IP托管
    path: "/trusteeship",
    name: "trusteeship",
    component: () =>
      import(
        /* webpackChunkName: "trusteeship" */ "../views/Operate/Trusteeship.vue"
      ),
  },
  {
    //运营服务 -> IP运营开发
    path: "/operationaldevelopment",
    name: "operationaldevelopment",
    component: () =>
      import(
        /* webpackChunkName: "operationaldevelopment" */ "../views/Operate/OperationalDevelopment.vue"
      ),
  },
  {
    //运营服务 -> IP需求开发
    path: "/demand",
    name: "demand",
    component: () =>
      import(
        /* webpackChunkName: "demand" */ "../views/Operate/Demand.vue"
      ),
  },
  {
    //用户协议
    path: "/useragreement",
    name: "useragreement",
    component: () =>
      import(
        /* webpackChunkName: "useragreement" */ "../views/UserAgreement.vue"
      ),
  },
];

const base = process.env.VUE_APP_BASE;

const router = new VueRouter({
  mode: 'history',
  base,
  routes,
});

export default router;
